import React from 'react'
import AnimateImageOne from './AnimateImageOne'
import AnimateTitleOne from './AnimatedTitleOne'

const CreativeLab = () => {
    return (
        <section className='section-creative-lab section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-7'>
                    <div className='animated-image-wrapper text-center'>
                        <AnimateImageOne/>
                    </div>
                </div>
                <div className='col-md-5'>
                   <div className='section-content-wrapper'>
                     <div className='section-title'>
                        <AnimateTitleOne/>
                     </div>
                     <div className='section-paragraph'>
                        <p>Fashion is a reflection of time — ever-evolving, expressive, and infinitely diverse. At <strong>India Embroidery Co.</strong>, we translate this spirit into timeless creations that speak the language of both tradition and innovation. For years, we have been crafting high-quality embroideries and garments for our global partners — designs that are in the now, yet rooted in the eternal artistry of India. Every stitch we create tells a story of meticulous craftsmanship, thoughtful design, and a passion for preserving heritage while embracing the modern aesthetic.</p>
                        <p>Our work celebrates the Indian art of hand embroidery, breathing new life into it through contemporary silhouettes and global sensibilities.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default CreativeLab